import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check, BookOpen } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export default function CourseDetail() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [course, setCourse] = useState<any>(null);
  const [lessons, setLessons] = useState<any[]>([]);
  const [done, setDone] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!slug) return;
    (async () => {
      const { data: c } = await supabase.from("courses").select("*").eq("slug", slug).maybeSingle();
      if (!c) return;
      setCourse(c);
      const { data: l } = await supabase.from("lessons").select("*").eq("course_id", c.id).eq("published", true).order("sort_order");
      setLessons(l || []);
      if (user && l?.length) {
        const { data: p } = await supabase.from("lesson_progress").select("lesson_id").in("lesson_id", l.map((x) => x.id));
        setDone(new Set((p || []).map((x: any) => x.lesson_id)));
      }
    })();
  }, [slug, user]);

  if (!course) return <p>Loading…</p>;
  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      <div>
        <Badge>{course.jlpt_level}</Badge>
        <h1 className="text-3xl font-bold mt-2">{course.title}</h1>
        <p className="text-muted-foreground mt-1">{course.description}</p>
      </div>
      <div className="space-y-2">
        {lessons.map((l, i) => (
          <Link key={l.id} to={`/courses/${slug}/lessons/${l.slug}`}>
            <Card className="hover:shadow-md transition-shadow">
              <CardContent className="p-4 flex items-center gap-3">
                <div className="h-8 w-8 rounded-full bg-muted flex items-center justify-center text-sm font-medium">
                  {done.has(l.id) ? <Check className="h-4 w-4 text-green-600" /> : i + 1}
                </div>
                <BookOpen className="h-4 w-4 text-muted-foreground" />
                <span className="font-medium">{l.title}</span>
              </CardContent>
            </Card>
          </Link>
        ))}
        {!lessons.length && <p className="text-muted-foreground">No lessons yet.</p>}
      </div>
    </div>
  );
}
